import { SET_MODALS } from './actionTypes';

export const setModals = value => {
  return (dispatch, getState) => {
    if (Array.isArray(value)) {
      return dispatch({ type: SET_MODALS, modals: value });
    }
    const { modals } = getState().commonStore;
    return dispatch({ type: SET_MODALS, modals: [...modals, value] });
  };
};
